import OutsideMigration from './OutsideMigration'
export default OutsideMigration
